import { render, staticRenderFns } from "./EditorDialog.vue?vue&type=template&id=6f7eaed7&"
import script from "./EditorDialog.vue?vue&type=script&lang=js&"
export * from "./EditorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports